import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [
  {
    path: '/new',
    name: 'index',
    component: () => import(/* webpackChunkName: "login" */ '../views/index/index.vue'),
    meta: {
      TabbarShow: false // 不需要显示
    }
  },
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/home/index.vue'),
    meta: {
      TabbarShow: false // 不需要显示
    }
  },
  {
    path: '/category',
    name: 'category',
    component: () => import(/* webpackChunkName: "category" */ '../views/Pages/category/index.vue'),
    meta: {
      TabbarShow: true // 不需要显示
    }
  },
  {
    path: '/lips',
    name: 'lips',
    component: () => import(/* webpackChunkName: "lips" */ '../views/Pages/lips/index.vue'),
    // redirect: '/lips/gloss',
    children: [
      {
        path: '/lips/gloss',
        name: 'gloss',
        component: () => import(/* webpackChunkName: "gloss" */ '../views/Pages/lips/components/gloss/index.vue'),
        meta: {
          TabbarShow: true // 不需要显示
        }
      },
    ],
    meta: {
      TabbarShow: true // 不需要显示
    }
  },
  {
    path: '/colour',
    name: 'colour',
    component: () => import(/* webpackChunkName: "colour" */ '../views/Pages/colour/index.vue'),
    // redirect: '/colour/tools',
    children: [
      {
        path: '/colour/tools',
        name: 'tools',
        component: () => import(/* webpackChunkName: "tools" */ '../views/Pages/colour/components/tools/index.vue'),
        meta: {
          TabbarShow: true // 不需要显示
        }
      },
    ],
    meta: {
      TabbarShow: true // 不需要显示
    }
  },
  {
    path: '/jointly',
    name: 'jointly',
    component: () => import(/* webpackChunkName: "jointly" */ '../views/Pages/jointly/index.vue'),
    // redirect: '/jointly/tools',
    children: [
      {
        path: '/jointly/tools',
        name: 'tools',
        component: () => import(/* webpackChunkName: "tools" */ '../views/Pages/jointly/components/tools/index.vue'),
        meta: {
          TabbarShow: true // 不需要显示
        }
      },
    ],
    meta: {
      TabbarShow: true // 不需要显示
    }
  },
  {
    path: '/makeup',
    name: 'makeup',
    component: () => import(/* webpackChunkName: "makeup" */ '../views/Pages/makeup/index.vue'),
    // redirect: '/makeup/remover',
    children: [
      {
        path: '/makeup/remover',
        name: 'remover',
        component: () => import(/* webpackChunkName: "remover" */ '../views/Pages/makeup/components/remover/index.vue'),
        meta: {
          TabbarShow: true // 不需要显示
        }
      },
    ],
    meta: {
      TabbarShow: true // 不需要显示
    }
  },
  {
    path: '/flawlesslook',
    name: 'flawlesslook',
    component: () => import(/* webpackChunkName: "flawlesslook" */ '../views/Pages/flawlesslook/index.vue'),
    // redirect: '/flawlesslook/base',

    children: [
      {
        path: '/flawlesslook/base',
        name: 'base',
        component: () => import(/* webpackChunkName: "base" */ '../views/Pages/flawlesslook/components/base/index.vue'),
        meta: {
          TabbarShow: true // 不需要显示
        }
      },
      {
        path: '/flawlesslook/powder',
        name: 'powder',

        component: () => import(/* webpackChunkName: "powder" */ '../views/Pages/flawlesslook/components/powder/index.vue'),
        meta: {
          TabbarShow: true // 不需要显示
        }
      },
      {
        path: '/flawlesslook/blush',
        name: 'blush',
        component: () => import(/* webpackChunkName: "blush" */ '../views/Pages/flawlesslook/components/blush/index.vue'),
        meta: {
          TabbarShow: true // 不需要显示
        }
      }
    ],
    meta: {
      TabbarShow: true // 不需要显示
    }
  },
  // 精致眼眉
  {
    path: '/eyebrow',
    name: 'eyebrow',
    component: () => import(/* webpackChunkName: "eyebrow" */ '../views/Pages/eyebrow/index.vue'),
    // redirect: '/eyebrow/shadow',
    children: [
      { // 眼影
        path: '/eyebrow/shadow',
        name: 'shadow',
        component: () => import(/* webpackChunkName: "shadow" */ '../views/Pages/eyebrow/components/shadow/index.vue'),
        meta: {
          TabbarShow: true // 不需要显示
        }
      },
      { // 眼线
        path: '/eyebrow/liner',
        name: 'liner',
        component: () => import(/* webpackChunkName: "liner" */ '../views/Pages/eyebrow/components/liner/index.vue'),
        meta: {
          TabbarShow: true // 不需要显示
        }
      },
      { // 睫毛
        path: '/eyebrow/lash',
        name: 'lash',
        component: () => import(/* webpackChunkName: "lash" */ '../views/Pages/eyebrow/components/lash/index.vue'),
        meta: {
          TabbarShow: true // 不需要显示
        }
      },
      { // 眉装
        path: '/eyebrow/brow',
        name: 'brow',
        component: () => import(/* webpackChunkName: "brow" */ '../views/Pages/eyebrow/components/brow/index.vue'),
        meta: {
          TabbarShow: true // 不需要显示
        }
      },
    ],
    meta: {
      TabbarShow: true // 不需要显示
    }
  },
  {
    path: '/girls',
    name: 'girls',
    component: () => import(/* webpackChunkName: "girls" */ '../views/girls/index.vue'),
    meta: {
      TabbarShow: true // 不需要显示
    }
  },
  {
    path: '/brand',
    name: 'brand',
    component: () => import(/* webpackChunkName: "brand" */ '../views/brand/index.vue'),
    meta: {
      TabbarShow: true // 不需要显示
    }
  },
  // {
  //   path: '/jointly',
  //   name: 'jointly',
  //   component: () => import(/* webpackChunkName: "jointly" */ '../views/jointly/index.vue'),
  //   meta: {
  //     TabbarShow: true // 不需要显示
  //   }
  // },
  {
    path: '/message',
    name: 'message',
    component: () => import(/* webpackChunkName: "message" */ '../views/message/index.vue'),
    meta: {
      TabbarShow: true // 不需要显示
    }
  }

  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes,
  //判断路由跳转之后是否是发生滚动 如果发生了滚动返回到最上面
  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop;
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router
